
import { Box } from '@mui/material';


const Liveboard = () => {
    return (
        <Box sx={{ alignItems: 'center'}}>

        </Box>
    );
}

export default Liveboard;
